var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.piiAuthorized
    ? _c(
        "span",
        [
          _c(
            "el-dropdown",
            {
              attrs: { trigger: "click", disabled: !_vm.isReady },
              on: { command: _vm.handlePLCRequest },
            },
            [
              _c("span", { staticClass: "choose_plc_request_button" }, [
                _c(
                  "span",
                  { staticStyle: { "text-decoration": "underline" } },
                  [
                    !_vm.isReady
                      ? _c("i", {
                          staticClass: "el-icon-loading el-icon--left",
                        })
                      : _vm._e(),
                    _vm._v("\n        Start PLC Request\n      "),
                  ]
                ),
                _vm._v(" "),
                _c("i", { staticClass: "el-icon-caret-bottom el-icon--right" }),
              ]),
              _vm._v(" "),
              _vm.isReady
                ? _c(
                    "el-dropdown-menu",
                    {
                      staticClass: "plc-request-dropdown",
                      staticStyle: {
                        "max-height": "unset !important",
                        overflow: "unset !important",
                      },
                      attrs: { slot: "dropdown" },
                      slot: "dropdown",
                    },
                    [
                      _c(
                        "el-tooltip",
                        {
                          attrs: {
                            disabled:
                              _vm.eligibility.replacement.isUserAllowed &&
                              !_vm.eligibility.replacement.noBypassable,
                            placement: "right",
                            content: _vm.replacementTooltip,
                          },
                        },
                        [
                          _c(
                            "span",
                            [
                              _c(
                                "el-dropdown-item",
                                {
                                  directives: [
                                    {
                                      name: "acl",
                                      rawName: "v-acl.show",
                                      value: {
                                        permission: "create",
                                        on: "ReplaceRequest",
                                      },
                                      expression:
                                        "{permission: 'create', on: 'ReplaceRequest'}",
                                      modifiers: { show: true },
                                    },
                                  ],
                                  staticClass: "plc_request_item",
                                  class: {
                                    "new-disabled": _vm.disableReplacement,
                                  },
                                  attrs: {
                                    type: "text",
                                    disabled: _vm.disableReplacement,
                                    command: "replace",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n            Replace Device\n          "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-tooltip",
                        {
                          attrs: {
                            disabled:
                              _vm.eligibility.parts.isUserAllowed &&
                              !_vm.eligibility.parts.noBypassable,
                            placement: "right",
                            content: _vm.partsTooltip,
                          },
                        },
                        [
                          _c(
                            "span",
                            [
                              _c(
                                "el-dropdown-item",
                                {
                                  directives: [
                                    {
                                      name: "acl",
                                      rawName: "v-acl.show",
                                      value: {
                                        permission: "create",
                                        on: "PartsRequest",
                                      },
                                      expression:
                                        "{permission: 'create', on: 'PartsRequest'}",
                                      modifiers: { show: true },
                                    },
                                  ],
                                  staticClass: "plc_request_item",
                                  class: { "new-disabled": _vm.disableParts },
                                  attrs: {
                                    type: "text",
                                    disabled: _vm.disableParts,
                                    command: "parts",
                                  },
                                },
                                [_vm._v("\n            Send Parts\n          ")]
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-tooltip",
                        {
                          attrs: {
                            disabled:
                              _vm.eligibility.refund.isUserAllowed &&
                              !_vm.eligibility.refund.noBypassable,
                            placement: "right",
                            content: _vm.refundTooltip,
                          },
                        },
                        [
                          _c(
                            "span",
                            [
                              _c(
                                "el-dropdown-item",
                                {
                                  directives: [
                                    {
                                      name: "acl",
                                      rawName: "v-acl.show",
                                      value: {
                                        permission: "create",
                                        on: "RefundRequest",
                                      },
                                      expression:
                                        "{permission: 'create', on: 'RefundRequest'}",
                                      modifiers: { show: true },
                                    },
                                  ],
                                  staticClass: "plc_request_item",
                                  class: { "new-disabled": _vm.disableRefund },
                                  attrs: {
                                    type: "text",
                                    disabled: _vm.disableRefund,
                                    command: "refund",
                                  },
                                },
                                [_vm._v("\n            Refund\n          ")]
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }